import { type MsClarityAdapter } from './ms-clarity.adapter';

/**
 * Analytics module
 * @author filipditrich <ditrich@nfctron.com>
 * @export
 */
export class AnalyticsModule {
	public msClarityAdapter: MsClarityAdapter;

	constructor(msClarityAdapter: MsClarityAdapter) {
		this.msClarityAdapter = msClarityAdapter;
	}
}
